import { Button, FeaturedIcon } from "@light-technology/components";
import { LinkExternal01, SearchLg } from "@untitledui/icons";
import { DOCS_QUICKSTART_URL } from "../../utilities/constants";

type AccountsEmptyStateProps = {
  hasActiveFilters: boolean;
};

export const AccountsEmptyState = ({
  hasActiveFilters,
}: AccountsEmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-lg text-center">
      <FeaturedIcon color="gray" theme="modern" size="lg" icon={SearchLg} />
      <div className="text-md font-semibold">
        {hasActiveFilters
          ? "No accounts match your filters"
          : "No accounts found"}
      </div>
      <div className="text-sm text-tertiary">
        {hasActiveFilters
          ? "Try adjusting your search or filter criteria to find what you're looking for."
          : "Start enrolling your first customer to see customer account information appear here."}
      </div>
      {!hasActiveFilters && (
        <Button href={DOCS_QUICKSTART_URL} iconLeading={LinkExternal01}>
          Read quickstart
        </Button>
      )}
    </div>
  );
};
